// Libraries
import * as React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { ToastProvider } from 'react-toast-notifications';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './HOC/i18n';

// Components
import PortalRouter from './components/PortalRouter';
import history from './utils/history';
import { ToastElement, ToastContainer } from './components/common/toastMessage';

const App: React.FC<unknown> = () => {
    return (
        <ConnectedRouter history={history}>
            <ToastProvider components={{ Toast: ToastElement, ToastContainer }}>
                <I18nextProvider i18n={i18n}>
                    <PortalRouter />
                </I18nextProvider>
            </ToastProvider>
        </ConnectedRouter>
    );
};

export default App;
